import PortalInterface from "../Interfaces/PortalInterface";
import GameInterface from "../Interfaces/GameInterface";

export default class Portal implements PortalInterface
{
    game: GameInterface;
    el: HTMLElement;

    constructor(name: string)
    {
        this.el = document.createElement('div');
        this.el.id = name;
        this.el.classList.add('Portal');
    }

    render(): HTMLElement
    {
        return this.el;
    }

    setGame(game: GameInterface)
    {
        this.game = game;

        let _self = this;

        this.el.addEventListener('PlayerInteraction', () => {
            _self.game.loadNextLevel();
        });
    }
}
